import React from 'react';
import styled from 'styled-components';
import { number, string } from 'prop-types';

const StyledBarBox = styled('div')(({ theme }) => ({
  height: '12px',
  maxHeight: '12px',
  flex: '1',
  borderRadius: theme.radii[3],
  background: theme.colors.greyVerylight
}));

const StyledBar = styled('div')(({ theme, percentage }) => ({
  borderRadius: '25px',
  height: '12px',
  maxHeight: '12px',
  position: 'relative',
  width: `${percentage}%`,
  background: theme.colors.mainLight,
  transition: 'width .3s ease'
}));

const ProgressionBar = ({ percentage, 'data-cy': dataCy }) => (
  <StyledBarBox>
    <StyledBar percentage={percentage} data-cy={dataCy} />
  </StyledBarBox>
);

ProgressionBar.propTypes = {
  percentage: number,
  'data-cy': string
};

export default ProgressionBar;
